import React, { useEffect } from 'react';
import { getProjectImgAndShareIcon } from 'utils/projectHelpers';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getProjects } from 'app/routes/Dashboard/actions/projects';
import CheckBox from '../CheckBox';
import Loading from '../Loading';

const ProjectCheckboxSelection = ({ projectIDs, setProjectIds, setShowProjectCreation }) => {
  const { t } = useTranslation();
  const projectsObj = useSelector(state => state.projects);
  const projects = Object.values(projectsObj || {});

  const onFormChange = item => {
    const tempData = [...projectIDs];
    if (tempData.includes(item)) {
      tempData.splice(tempData.indexOf(item), 1);
    } else {
      tempData.push(item);
    }
    setProjectIds(tempData);
  };

  useEffect(() => {
    if (!projectsObj) getProjects();
  }, []);

  return (
    <div className='col-12'>
      <div className='d-flex align-items-center justify-content-between mb-8'>
        <p className='text-dark fw-500 mb-0'>{t('your_projects')}</p>
        <button className='btn p-0 text-primary text-underline' onClick={() => setShowProjectCreation(true)}>
          {t('btn_create_new_project')}
        </button>
      </div>
      <div className='scroll-y-content max-h-300 pb-10'>
        {projects.map((item, index) => {
          const { Icon, image } = getProjectImgAndShareIcon(item);
          return (
            <CheckBox
              key={index}
              className='mb-10'
              label={
                <div className='d-flex align-items-center cursor-pointer'>
                  <div className='project-img-type mr-8 position-relative'>
                    <img width='54' height='54' src={image} alt='project' />
                    <div className='action-btn right-bottom-corner is-small text-center'>
                      <Icon width='18' height='18' />
                    </div>
                  </div>
                  {item.name}
                </div>
              }
              id={`check${item.id}`}
              name={`check${item.id}`}
              checked={projectIDs.includes(item.id)}
              onChange={onFormChange.bind(null, item.id)}
            />
          );
        })}
        {!projectsObj && <Loading />}
      </div>
    </div>
  );
};

export default ProjectCheckboxSelection;
